/**
 * @description Get communities with auth context (in case of agent fetches only communities that are assigned to them)
 * @param {Axios} axiosInstance
 */
export const getCommunitiesWithAuthContext = async (axiosInstance) => {
    const res = await axiosInstance.get('/community/with-auth');
    return res.data;
};